import ShopaholicCartAdd from '@lovata/shopaholic-cart/shopaholic-cart-add';
import ButtonBlock from '../../product/product-buy/button-block';

export default new class AddToCart {
  constructor() {
    this.btnAddCart = '._shopaholic-cart-add';
    this.obShopaholicCartAdd = new ShopaholicCartAdd();
    this.sMiniCartWrapper = '._shopaholic-cart-mini-wrapper';
    this.drawerCloseSelector = '.buy-drawer-panel__close';
    this.mediaQueryList = window.matchMedia('(min-width: 769px)');

    this.handleClick();
  }

  handleClick() {
    document.addEventListener('click', (e) => {
      if (!e.target.matches(`${this.btnAddCart}`)) return;

      e.preventDefault();

      const form = $(e.target).closest('form');

      if (typeof form.attr('form-id') === 'undefined' || !form.attr('form-id').match(/buy-form/g)) return;

      this.formData = Object.fromEntries(new URLSearchParams(form.serialize()));

      // this.obShopaholicCartAdd.sendAjaxRequest(e.target);
      this.addOfferToCart(this.formData.offer_id);
    });
  }

  addOfferToCart(offerID) {
    $.request('Cart::onAdd', {
      data: { cart: [this.formData] },
      context: this,
      success(response) {
        if (!!response && response.status) {
          this.updateBlock();
          ButtonBlock.update(offerID, true);

          if (!this.isDesktop()) document.querySelector(`${this.drawerCloseSelector}`).click();
        }

        // button.popover('show');
        setTimeout(() => {
          // button.popover('hide');
        }, 1500);
      },
    });
  }

  updateBlock() {
    $.request('Cart::onGetData', {
      update: {
        'product/cart/cart-mini/cart-info/cart-info': `${this.sMiniCartWrapper}`,
      },
    });
  }

  isDesktop() {
    return this.mediaQueryList.matches;
  }
}();
